"use client";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import React from "react";
// import { NavigationBar } from "./navigationBar";
import { SxProps, Theme } from "@mui/material/styles";
import useDevice from "@/hooks/useDevice";
import { useRouter } from "next/navigation";
import { GoogleLogin } from "@react-oauth/google";
import { useUser } from "@/context/userContext";
import type { CredentialResponse } from "@react-oauth/google";
import userService from "@/api/services/user.service";
import gaService from "@/api/services/ga.service";
import { useConversational } from "@/context/ConversationalContext";
import { NavigationBar } from "./navigationBar";
export type GooglePayload = {
  sub: string;
  email: string;
  email_verified: boolean;
  name: string;
  picture: string;
};

export function parseJwt<T = any>(token: string): T {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(jsonPayload);
}

interface HeaderProps {
  showLogo?: boolean;
  sx?: SxProps<Theme>;
  gotoHome?: VoidFunction;
}

const Header: React.FC<HeaderProps> = ({ showLogo = true, sx, gotoHome }) => {
  const isMobile = useDevice();
  const router = useRouter();
  const { user, setUser } = useUser();
  const {loadSessions} = useConversational()
  const handleGoogleSuccess = async (res: CredentialResponse) => {
    if (!res.credential) {
      console.error("No credential returned from Google");
      return;
    }
    try {
      gaService.googleLoginClicked();
      const payload = parseJwt<GooglePayload>(res.credential);
      // store entire user in context (and it auto-syncs to localStorage)
      const loginRes = await userService.authenticateUser({
        token: res.credential,
      });
      localStorage.setItem("trends_user", loginRes?.data);
      setUser({
        name: payload.name,
        email: payload.email,
        picture: payload.picture,
        sub: payload.sub,
        
      });
      loadSessions()
    } catch (err) {
      console.error("JWT parse failed:", err);
    }
  };

  const handleGoogleError = () => {
    console.error("Google One-Tap login failed");
  };
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
        animationDelay: "500ms",
        ...sx,
      }}
      className="animate__animated animate__fadeInDown no-print"
    >
      {showLogo ? (
        <Box
          component="img"
          src={isMobile ? "https://sr-cdn-1.shiprocket.in/sr-promise/images/trends_icon_small.svg" : "https://trends.shiprocket.in/assets/icons/logo-white.svg"}
          alt="Logo"
          sx={{ height: isMobile ? "30px" : "auto", cursor: "pointer" }}
          onClick={() =>{
            gotoHome ? gotoHome() : router.replace("/")
          }}
        />
      ) : <Box/>}


      {/* <Box
        sx={{
          left: "50%",
          zIndex: 1,
          top: "15px",
        }}
      >
        <NavigationBar />
      </Box> */}

      {true &&
        (user ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: "4px 8px",
              backgroundColor: "rgba(255,255,255,0.1)",
              borderRadius: "20px",
              cursor: "pointer",
            }}
            onClick={() => {}}
          >
            <Avatar
              src={user.picture}
              alt={user.name}
              sx={{ width: 32, height: 32 }}
            />
            {!isMobile  && <Typography variant="body2" color="inherit">
              {user.name.split(" ")[0]}
            </Typography>}
          </Box>
        ) : (
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            useOneTap
            theme="filled_black"
            type={isMobile ? "icon" : "standard"}
          />
        ))}
    </Box>
  );
};

export default Header;
